import { render, staticRenderFns } from "./video-play.vue?vue&type=template&id=1ad61b8b"
import script from "./video-play.vue?vue&type=script&lang=js"
export * from "./video-play.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports